import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faqItems } from "../../../mocks/process";

export default function FaqSection() {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-14 md:py-20 bg-cream">
      <div className="container-main px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <span className="tag-label mb-3 inline-block">{t("process.faq.label")}</span>
          <h2 className="mb-3">{t("process.faq.title")}</h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`bg-white rounded-xl border transition-all duration-300 ${
                  isOpen ? "border-champagne/40 shadow-sm" : "border-warm-gray/20"
                }`}
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-start gap-3 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                >
                  <span className="w-7 h-7 rounded-full bg-champagne/10 flex items-center justify-center shrink-0 mt-0.5">
                    <i className={`ri-${isOpen ? "subtract" : "add"}-line text-champagne text-base`} />
                  </span>
                  <span className="font-semibold text-graphite text-base md:text-base leading-snug">
                    {t(item.questionKey)}
                  </span>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 pb-5 md:px-6 md:pb-6 pl-14 md:pl-16">
                    <p className="text-medium-gray text-base leading-relaxed">
                      {t(item.answerKey)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}